export default {
      id: "ic_filter_rapid_games-usage",
      viewBox: "0 0 18 18",
      url: "/" + "images/icons.3.109.2.svg#ic_filter_rapid_games-usage",
      toString: function () {
        return this.url;
      }
    }